let initialState = {
	widgetObj: {
		title: null,
		type: null,
		graph_type: null,
		is_custom: false,
		primary: null,
		secondary: null,
		splits: null,
		filters: null,
	},
	widgetList: [],
	allSelectedCheckbox: false,
	updatedGraphData: {},
	isSelected: {},
};

const Widget = (state = initialState, action) => {
	switch (action.type) {
		case "SET_ADDWIDGET":
			return {
				...state,
				widgetObj: action.payload,
			};
		case "SET_WIDGET_LIST":
			return {
				...state,
				widgetList: action.payload,
			};
		case "SET_ALL_SELECTED_CHECKBOX":
			return {
				...state,
				allSelectedCheckbox: action.payload,
			};
		case "SET_IS_SELECTED":
			return {
				...state,
				isSelected: action.payload,
			};
		case "SET_UPDATED_GRAPH_DATA":
			return {
				...state,
				updatedGraphData: action.payload,
			};

		default:
			return state;
	}
};

export default Widget;
